export default __webpack_public_path__ + "static/live-like-a-local-when-you-travel-972eece7f2eec5ca9625ae4cb80da236.jpg";